<template>
    <BaseCard
        class="bg-surface/50 animate-pulse"
        data-spec-class="card-skeleton"
    >
        <template #avatar>
            <div class="h-10 w-10 rounded-full bg-muted" />
        </template>

        <BaseCardTitle>
            <div class="mb-3 h-4 w-1/3 rounded-sm bg-muted" />
        </BaseCardTitle>
        <BaseCardContent>
            <div class="h-4 w-2/3 rounded-sm bg-secondary--inverse" />
        </BaseCardContent>
    </BaseCard>
</template>
